import { render, staticRenderFns } from "./AddPeopleEvent.vue?vue&type=template&id=4d6b018e&scoped=true&lang=pug"
import script from "./AddPeopleEvent.vue?vue&type=script&lang=js"
export * from "./AddPeopleEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6b018e",
  null
  
)

export default component.exports